export default __webpack_public_path__ + "static/media/020_start.first.2793576e.avif";